import { rest } from '@0xtorch/core'
import { z } from 'zod'
import type { TestApiAuthentication } from '../types'
import { bitbankApiEndpoint } from './constants'
import { errorResponseSchema } from './schemas'
import { createPrivateGetHeaders } from './utils'

const responseSchema = z.object({
  success: z.literal(1),
  data: z.unknown(),
})

export const testBitbankApiAuthentication: TestApiAuthentication = async ({
  apiKey,
  apiSecret,
  proxy,
  proxyHeaders,
}) => {
  const url = new URL('/v1/user/assets', bitbankApiEndpoint)
  const response = await rest(
    proxy === undefined
      ? url.toString()
      : `${proxy}${encodeURIComponent(url.toString())}`,
    {
      fetchOptions: {
        method: 'GET',
        headers: {
          ...proxyHeaders,
          ...(await createPrivateGetHeaders({
            apiKey,
            apiSecret,
            urlPath: url.pathname,
            query: '',
          })),
        },
      },
      schema: z.union([responseSchema, errorResponseSchema]),
    },
  )
  if (response.success === 1) {
    return true
  }
  return false
}
